// Contact details for document scanning only. Mail scanning uses its own chrome.
export const SCANNING_PHONE = "1300 338 365";
export const SCANNING_PHONE_HREF = "tel:1300338365";
